import { gql } from 'graphql-request';
import { requestWithAuth } from '@/utilities/graphQLClient';

import { WATCHLIST_ITEM_FRAGMENT } from '@/hooks/useWatchlist';
import type { WatchlistItemFragmentType } from '@/hooks/useWatchlist';

type Response =
  | { errors: Error[] }
  | { addFairValue: WatchlistItemFragmentType };

export interface Args {
  companyId: string;
  fairValue: number;
  watchlistId: string;
}

export const queryFn = async ({ companyId, fairValue, watchlistId }: Args) => {
  const response = await requestWithAuth<Response>(
    gql`
      mutation addFairValue(
        $companyId: String!
        $fairValue: Float!
        $watchlistId: String!
      ) {
        addFairValue(
          companyId: $companyId
          fairValue: $fairValue
          watchlistId: $watchlistId
        ) {
          ...watchlistItemFields
        }
      }
      ${WATCHLIST_ITEM_FRAGMENT}
    `,
    {
      companyId,
      fairValue,
      watchlistId,
    }
  );

  if ('addFairValue' in response) {
    return response.addFairValue;
  }

  const message = response.errors.map((e: Error) => e.message).join(' - ');
  throw new Error(message);
};
